import {
    FETCH_ACTIVITIES,
    FETCH_ACTIVITIES_SUCCESS,
    FETCH_ACTIVITIES_ERROR,

    FETCH_ANALYTICS_DATA_SUCCESS,
    CLEAR_STORE
} from "../actions/types";

const INITIAL_STATE = {
    newStoreValuev11072019: true,

    activities: [],
    isLoadingActivities: false,
    anaylticData: [],
}
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_ACTIVITIES:
            return {
                ...state,
                isLoadingActivities: true
            }
        case FETCH_ACTIVITIES_SUCCESS:
            return {
                ...state,
                isLoadingActivities: false,
                activities: action.payload.activities
            }
        case FETCH_ACTIVITIES_ERROR:
            return {
                ...state,
                isLoadingActivities: false
            }
        case FETCH_ANALYTICS_DATA_SUCCESS:
            return {
                ...state,
                anaylticData: action.payload.anaylticData
            }
        case CLEAR_STORE:
            return {
                ...INITIAL_STATE,
                isFirstTime: state.isFirstTime
            }
        default:
            return state
    }
}
